import Vue from "vue";
import Vuex from "vuex";
import getToken from "@/plugins/wApi/lib/getToken";

import AccordionListStore from './accordionlist' ; 
import LNBStore from './lnb' ; 
import ProcessSearch from './ProcessSearch' ;
import ProcessEditor from './ProcessEditor';

import CommonNewStore from './commnew' ; 
import AcListNewStore from './aclist_new' ; 
import TagAddPopStrore from './tagaddpop' ; 

import Dictionary from './dictionary' ;
import Hub from './hub' ;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loaded: false,
    user: null,
    draw: {
      mode: null,
    },
  },
  mutations: {
    setState(s: any, [key, value]) {
      s[key] = value;
    },
    setDraw(s: any, payload) {
      s.draw = { ...s.draw, ...payload };
    },
  },
  getters: {
    loaded(s) {
      return s.loaded;
    },
    user(s) {
      return s.user;
    },
    draw(s) {
      return s.draw;
    },
  },
  actions: {
    async getMe({ dispatch, commit }, $wApi) {
      try {
        if (!getToken().Authorization) return null;
        const user = await $wApi.user.me();
        commit("setState", ["user", user]);
        return user;
      } catch (error) {
        console.log("error", error);
      } finally {
        commit("setState", ["loaded", true]);
      }
    },
  },
  modules: {
    lnb : LNBStore , 
    ProcessSearch ,
    ProcessEditor , 
    AcListComm : AccordionListStore ,

    CommNew : CommonNewStore , 
    AcListNew : AcListNewStore , 
    TagAddPopComm : TagAddPopStrore , 
    
    Dictionary : Dictionary,
    Hub : Hub,
  },
});
